// extracted by mini-css-extract-plugin
export default {"meatball":"case-drafts-tiles-meatball__meatball--pr9lr"};